import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { Company } from '../models/Company';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class CompanyManagementService {
  protected ManagementServiceUrl = AppConfig.settings.apiServer.managementServiceUrl;

  constructor(private http: HttpClient)
  { }

  getCompanybyBoardID(boardID: string): Observable<any> {
    const url = `${this.ManagementServiceUrl}/company/GetCompanybyBoardID?BoardID=${boardID}`;
    return this.http.get<any>(url).pipe(
      map(response => {
        return {
          ...response.data, 
        } as Company;
      })
    );
  }

  getCountries(): Observable<any> {
    const url = `${this.ManagementServiceUrl}/Country/GetCountries`;
    return this.http.get<any>(url).pipe(
      map(response => {     
        return response.data ;
      })
    );
  }



  ValidateVatID(CountryCode: string, IsEU: boolean, VatNumber: string, BoardId: string): Observable<Company> {
    const url = `${this.ManagementServiceUrl}/Company/ValidateVatID?CountryCode=${String(CountryCode)}&IsEU=${IsEU}&VatNumber=${String(VatNumber)}&BoardId=${String(BoardId)}`;
    return this.http.get<any>(url).pipe(
      map(response => {
   
       const name= (response.data.companyName)?response.data.companyName.replace(/\s+/g, ' ').trim():'';
        const company: Company = {        
          isValid: response.data.isValid,
          legalName:name ,
          address: response.data.companyAddress,       
        };
        return company;
      })
    );
  }

  UpdateCompany(company:Company) {
    const url = `${this.ManagementServiceUrl}/company/UpdateCompany`;
    const headers = {
      'Content-Type': 'application/json',
    };
    const body = JSON.stringify(company);
    return this.http.put<any>(url, body, { headers }).pipe(
      map(response => {
        return response ;
      })
    );
  }

  CreateCompany(company:Company) {
    const url = `${this.ManagementServiceUrl}/company/CreateCompany`;
    const headers = {
      'Content-Type': 'application/json',
    };
    const body = JSON.stringify(company);
    return this.http.post<any>(url, body, { headers }).pipe(
      map(response => {
        return response ;
      })
    );
  }

  GetParentBoards(Organization:string , userBoardID:string): Observable<any> {
    const url = `${this.ManagementServiceUrl}/Board/GetParentBoards?Organization=${String(Organization)}&BoardID=${String(userBoardID)}`;
    return this.http.get<any>(url).pipe(
     map(response => {  
        return response.data ;
      })
    );
  }
}